module.exports = __webpack_public_path__ + "static/media/vip-year.96ef8585.png";